// Pure core of the department (tenant) scoping decisions (#942). React-free —
// tenantScope.ts pulls in react + localStorage — so the Phones-page domain
// selection and auth-header building can run under node:test
// (see scopedDomain.test.ts).

export const ALL = 'all';

// The domain an operation should target: an explicitly selected department
// wins; "All" (or unset) falls back to the caller's default (usually the
// admin's home domain). Pure core of tenantScope.getScopedDomain.
export function resolveScopedDomain(activeTenant: string | null | undefined, fallback?: string | null): string | undefined {
  const a = activeTenant || ALL;
  return (a !== ALL ? a : (fallback || undefined)) || undefined;
}

// Authorization headers for hand-rolled fetch() calls. The token must come
// from lib/api getToken() (localStorage-backed, expiry-aware) — never a window
// global: window.__TOKEN was never assigned anywhere, so every request from
// the IP Phone Options modal silently failed auth (#942).
export function bearerHeaders(token: string | null | undefined, json = false): Record<string, string> {
  return {
    ...(json ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
